import moment from "moment";

import DoubleDoobleText from "../../icons/doubleDoobleText";

import { useTranslation } from "react-i18next";

import GradientButton from "components/ui/gradientButton/index.jsx";
import { PROMOTION_DATE_FORMAT } from "constants/date.constants.js";

const DoubleDoobleView = ({
	promotions,
	moreButtonHandler,
	handleOnActivatePromotions,
	disableBtnActivatePromotions = false,
}) => {
	const { t } = useTranslation();

	return (
		<>
			<div className="vs--promotion-modal-background">
				<div className="vs--promotion-modal-background-text">
					<DoubleDoobleText />
				</div>

				<div className="vs--promotion-modal-notification-info">
					<span className="vs--promotion-modal-notification-info-text">{t("common.becomeDoubleDooble")}</span>
					{promotions?.startTime && promotions?.endTime && (
						<span className="vs--promotion-modal-notification-info-date-info">
							{`${moment.utc(promotions.startTime).local().format(PROMOTION_DATE_FORMAT)} - ${moment.utc(promotions.endTime).local().format(PROMOTION_DATE_FORMAT)}`}
						</span>
					)}
				</div>
				<div className="vs--promotion-modal-notification-footer">
					<GradientButton onClick={moreButtonHandler}>{t("common.more")}</GradientButton>
					<GradientButton
						type="secondary"
						onClick={handleOnActivatePromotions}
						disabled={disableBtnActivatePromotions}
					>
						{t("common.activatePromotions")}
					</GradientButton>
				</div>
			</div>
		</>
	);
};
export default DoubleDoobleView;
